var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListLayoutRow28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.844C5 5.378 5.378 5 5.844 5h16.312a.844.844 0 110 1.688H5.844A.844.844 0 015 5.843zM5 11.281c0-.466.378-.844.844-.844h11.575a.844.844 0 110 1.688H5.844A.844.844 0 015 11.281zM5 16.719c0-.466.378-.844.844-.844h7.312a.844.844 0 110 1.688H5.844A.844.844 0 015 16.718zM5 22.156c0-.466.378-.843.844-.843h4.944a.844.844 0 010 1.687H5.844A.844.844 0 015 22.156z"
  })));
}
export default SvgListLayoutRow28;